import {
  AUTH_CHALLENGE_SET,
  AUTH_CHALLENGE_ERROR,
  AUTH_CHALLENGE_CLEAR,
  AUTH_CHALLENGE_RESEND_CODE_STARTED,
  AUTH_CHALLENGE_RESEND_CODE_SUCCEEDED,
  AUTH_CHALLENGE_RESEND_CODE_FAILED
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const challengeRaw = sessionStorage.getItem('authChallenge');

const defaultState = {
  challenge: challengeRaw ? JSON.parse(challengeRaw) : null,
  resendCodeStatus: statuses.idle,
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case AUTH_CHALLENGE_SET:
      return { ...state, challenge: action.payload };
    case AUTH_CHALLENGE_ERROR:
      return { ...state, error: action.payload };
    case AUTH_CHALLENGE_CLEAR:
      return { ...state, challenge: null, error: null };
    case AUTH_CHALLENGE_RESEND_CODE_STARTED:
      return { ...state, resendCodeStatus: statuses.loading, error: null };
    case AUTH_CHALLENGE_RESEND_CODE_SUCCEEDED:
      return {
        ...state,
        resendCodeStatus: statuses.succeeded,
        challenge: action.payload,
        error: null
      };
    case AUTH_CHALLENGE_RESEND_CODE_FAILED:
      return { ...state, resendCodeStatus: statuses.failed, error: action.payload };
    default:
      return state;
  }
};
